// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  objectId: __t.string().name("object_id"),
  assetId: __t.string().name("asset_id"),
  x: __t.i32(),
  y: __t.i32(),
  offsetX: __t.f32().name("offset_x"),
  offsetY: __t.f32().name("offset_y"),
  sizeMultiplier: __t.f32().name("size_multiplier"),
  flipHorizontal: __t.bool().name("flip_horizontal"),
  flipVertical: __t.bool().name("flip_vertical"),
  rotationSteps: __t.i32().name("rotation_steps"),
  layer: __t.string(),
  sortOrder: __t.i32().name("sort_order"),
});
